import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRightOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

import { styles } from './NearFilmsTable.styles'
import { KinohodBuyBtn, LinkBtn } from '../BuyBtn';
import { KinohodPortal } from '../kinohod';
import { generateBuyUrl } from '../../utils';
import { useKinohod } from '../useKinohod';

export const NearFilmsTable = (props) => {
  const navigate = useNavigate();
  const onClick = () => {
    navigate('/schedule');
  }

  const { isMobile, handleOpen, handleClose, showWidget, seanceId } = useKinohod();

  return (
    <div className={styles.wrapper}>
      <div className={styles.subWrapper}>
        {props.items.map((film) => (
          <div key={film.kinohodId} className={styles.row}>
            <div>{dayjs(film.datetime).utcOffset(film.datetime.slice(-6)).format('DD.MM   ·   HH:mm')}</div>
            <div><Link to={`/movies/${film.event.slug}`}>{film.event.title}</Link><span>{film.event.ageRestriction ? `${film.event.ageRestriction}+` : ''}</span></div>
            <div>{film.event.director}</div>
            <div>
              {film.event.type === 'EVENT' && film.event.buyUrl ? <LinkBtn text="БИЛЕТЫ" url={generateBuyUrl(film.event.buyUrl, film.datetime, film.event.slug)} /> :
                <KinohodBuyBtn kinohodId={film.kinohodId} buyText="БИЛЕТЫ" onClick={(seanceId) => {
                  if (isMobile) {
                    window.open(`https://kinohod.ru/widget/seances/${seanceId}?apikey=017abbb3-7f77-33e2-813b-098f4a8a564e&type=seance&_referrer=http%3A%2F%2Flocalhost%3A3000&__referrer=boxoffice`)
                  } else {
                    handleOpen(seanceId);
                  }
                }} />}
            </div>
          </div>
        ))}
        {!props.withoutFull && <div onClick={onClick} className={styles.btn}>
          СМОТРЕТЬ ПОЛНОЕ РАСПИСАНИЕ
          <ArrowRightOutlined />
        </div>}
      </div>
      {showWidget && <KinohodPortal seance={seanceId} onClose={handleClose} />}
    </div>
  )
}
